import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders, HttpParams} from '@angular/common/http';
import { AppConfig } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  //  API_STAFF_URL: any = AppConfig.API_BASE_URL;

  constructor(private http: HttpClient) { }

   listTemplate(token:any,data:any){
    const url = AppConfig.API_BASE_URL + 'client/listTemplate';
  
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
       'authorization': 'Bearer '+token
     });
     const options = { headers: headers };
    
     const body = data
     return this.http.post(url, body, options);
  
  
    }

     downloadTemplate(token:any,data:any){
    const url = AppConfig.API_BASE_URL + 'client/getTemplate';
  
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
       'authorization': 'Bearer '+token
     });
     const options = { headers: headers };
    
     const body = data
     return this.http.post(url, body, options);
  
  
    }

      uploadExcelTemplate(token:any,data:any){
        const url = AppConfig.API_BASE_URL + 'client/bulkEmailUpload';
      
        const headers = new HttpHeaders({
          // 'Content-Type': 'application/x-www-form-urlencoded',
          'authorization': 'Bearer '+token
        });
        const options = { headers: headers };
        
        const body = data
        return this.http.post(url, body, options);
      
      
        }


    addTemplate(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL + 'client/addTemplate';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url, body, options);
  
  
    }

   deleteTemplate(token:any,data:any){
    const url = AppConfig.API_BASE_URL + 'client/updateTemplate';
  
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
       'authorization': 'Bearer '+token
     });
     const options = { headers: headers };
    
     const body = data
     return this.http.post(url, body, options);
  
  
    }

    updateTemplate(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL + 'client/updateTemplate';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url, body, options);
  
  
    }

     uploadTemplate(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_STAFF_URL + 'upload/uploadTemplate';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url, body, options);
  
  
    }

    addSettings(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL + 'client/addSettings';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url, body, options);
  
  
    }

     updateSettings(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL + 'client/updateSettings';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url, body, options);
  
  
    }

     listSettings(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL + 'client/listSettings';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.get(url, options);
  
  
    }

     sendEmail(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL + 'client/sendMailToClient';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url,body, options);
  
  
    }

     generateReportDaily(token:any,data:any){

      console.log(data)
      const url =  AppConfig.API_URL +'CallDetails/listCallDetailsByDateRange';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url,body, options);
  
  
    }

      generateReportMonthly(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_URL+'CallDetails/listCallDetailsByMonth';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.post(url,body, options);
  
  
    }

     mailProgress(token:any,data:any){

      console.log(data)
      const url = AppConfig.API_BASE_URL+'client/getBulkEmailProgress';
    
      const headers = new HttpHeaders({
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
      
      const body = data
      return this.http.get(url, options);
  
  
    }




}
